import Gitbook from "/static/img/social-icons/gitbook-footer.svg";
import Discourse from "/static/img/social-icons/discourse-footer.svg";
import Twitter from "/static/img/social-icons/twitter-footer.svg";
import Github from "/static/img/social-icons/github-footer.svg";
import Discord from "/static/img/social-icons/discord-footer.svg";

export const categoryNames = [
  {
    name: "TRACER DAO",
  },
  {
    name: "PRODUCTS",
  },
  {
    name: "LEARN",
  },
  {
    name: "CONTRIBUTE",
  },
  {
    name: "GOVERN",
  },
  {
    name: "CONNECT",
  },
];

export const socialLinks = [
  {
    url: "https://docs.tracer.finance/",
    icon: Gitbook,
    alt: "Gitbook",
  },
  {
    url: "https://discourse.tracer.finance/",
    icon: Discourse,
    alt: "Discourse",
  },
  {
    url: "https://twitter.com/TracerDAO",
    icon: Twitter,
    alt: "Twitter",
  },
  {
    url: "https://github.com/tracer-protocol",
    icon: Github,
    alt: "Github",
  },
  {
    url: "https://discord.com/invite/tracerdao",
    icon: Discord,
    alt: "Discord",
  },
];

export const tracerDAOCategory = [
  {
    text: "Home",
    url: "/",
  },
  {
    text: "Research",
    url: "/learn",
  },
  {
    text: "News",
    url: "/radar",
  },
  {
    url: "/brand",
    text: "Brand Assets",
  },
  {
    text: "Legal and Privacy",
    url: "/privacy-policy",
  },
];

export const productsCategory = [
  {
    text: "Pools",
    url: "https://pools.tracer.finance",
  },
  {
    text: "Swaps",
    url: "",
  },
  {
    text: "Strategies",
    url: "",
  },
  {
    text: "Factory",
    url: "",
  },
];

export const learnCategory = [
  {
    text: "Whitepapers",
    url: "/learn",
  },
  {
    text: "Documentation",
    url: "https://docs.tracer.finance",
  },
  {
    text: "Audits",
    url: "/radar/sigma-prime-audit-response",
  },
];

export const contributeCategory = [
  {
    text: "Open Tasks",
    url: "https://app.dework.xyz/o/tracer-dao-3vNZC9t31aghwwUQH5Hqar",
  },
  {
    text: "Careers",
    url: "/careers",
  },
  {
    text: "Bounties",
    url: "https://docs.tracer.finance/tracer-1/service-providers/bounties",
  },
  {
    text: "Contributor Docs",
    url: "https://docs.tracer.finance/tracer-1/contribute",
  },
  {
    text: "Developers",
    url: "",
  },
];

export const governCategory = [
  {
    text: "Forum (Discourse)",
    url: "https://discourse.tracer.finance/",
  },
  {
    text: "Voting (Snapshot)",
    url: "https://snapshot.org/#/tracer.eth",
  },
];

export const connectCategory = [
  {
    text: "Discord",
    url: "https://discord.com/invite/tracerdao",
  },
  {
    text: "Twitter",
    url: "https://twitter.com/TracerDAO",
  },
  {
    text: "Medium",
    url: "https://medium.com/tracer-dao",
  },
  {
    text: "Mirror",
    url: "https://mirror.xyz/0xAeFedAb4bdf19F6FCA918cB66aD4ddF9cf8Eb4a9",
  },
  {
    text: "YouTube",
    url: "https://www.youtube.com/channel/UChQFEjLu4vaaS96iCRbasFg",
  },
];
